import { ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { RouteConstants } from '../constants/route-constant';

const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={RouteConstants.ROUTE_LOGIN} />
  );
};

export default PrivateRoute;
